import {
  B_04,
  BANNER_DEFAULTS,
  hideB04Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B04_PLASMIC_PROPS = {
  b04Eyebrow: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_04].eyebrow,
    description: "Eyebrow text (B04 only)",
    hidden: hideB04Props,
  },
  b04Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_04].heading,
    description: "Main heading (B04 only)",
    hidden: hideB04Props,
  },
  b04Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_04].description,
    description: "Description text (B04 only)",
    hidden: hideB04Props,
  },
  b04ButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_04].buttonText,
    description: "CTA button text (B04 only)",
    hidden: hideB04Props,
  },
  b04ButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "CTA button link type (B04 only)",
    hidden: hideB04Props,
  },
  b04ButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open CTA button in new tab (B04 only)",
    hidden: hideB04Props,
  },
  b04ButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB04Props(props) ||
      (props.b04ButtonLinkType !== OTHER_LINK_TYPE &&
        props.b04ButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b04ButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB04Props(props) ||
      (props.b04ButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b04ButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b04MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_04].mobileImg,
    description: "Mobile/tablet background image (B04 only)",
    hidden: hideB04Props,
  },
  b04DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_04].desktopImg,
    description: "Desktop background image (B04 only)",
    hidden: hideB04Props,
  },
  b04ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_04].imageAlt,
    description: "Image alt text (B04 only)",
    hidden: hideB04Props,
  },
  b04OverlayOpacity: {
    type: "number",
    defaultValue: BANNER_DEFAULTS[B_04].overlayOpacity,
    description: "Overlay opacity (0-1) (B04 only)",
    hidden: hideB04Props,
  },
};
